import DashboardIcon from "@mui/icons-material/Dashboard";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HomeIcon from "@mui/icons-material/Home";
import InsightsIcon from "@mui/icons-material/Insights";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from "@mui/icons-material/Settings";
import StarIcon from "@mui/icons-material/Star";
import { SvgIconComponent } from "@mui/icons-material";

export interface CedarShellNavItem {
  label: string;
  path: string;
  Icon: SvgIconComponent;
}

export const CEDAR_SHELL_NAV_ITEMS: CedarShellNavItem[] = [
  // CEDAR AI temporarily hidden here (nav item, route in App.tsx, and its PUBLIC_AUTHENTICATED_PATHS
  // entry) - still being finished on its own branch, not ready for development/UAT/prod yet.
  { label: "Home", path: "/home", Icon: HomeIcon },
  { label: "Favourites", path: "/favourites", Icon: StarIcon },
  { label: "Dashboards", path: "/dashboards", Icon: DashboardIcon },
  { label: "Downloads", path: "/analytics", Icon: InsightsIcon },
  { label: "Settings", path: "/settings", Icon: SettingsIcon },
  { label: "FAQ", path: "/faq", Icon: HelpOutlineIcon },
  { label: "Alerts", path: "/alerts", Icon: NotificationsIcon },
];
